import { IonCard, IonIcon } from "@ionic/react";
import {
  calendarClearOutline,
  checkmark,
  lockClosed,
  play
} from "ionicons/icons";
import moment from "moment";
import React, { useEffect, useState } from "react";
import ProgressBarAlt from "./ProgressBarAlt";
import { QuoQuestLevel } from "../types/quest";

const QuoQuestLevelCard = ({ level }: { level: QuoQuestLevel }) => {
  let nextUnclearedStage = level.stages.findIndex(stage => !stage.hasCleared);
  if (nextUnclearedStage === -1) {
    nextUnclearedStage = 0;
  }
  const [now, setNow] = useState(moment());
  useEffect(() => {
    const intervalRef = setInterval(() => {
      setNow(moment());
    }, 1000);
    return () => clearInterval(intervalRef);
  }, []);

  const getStatusElement = () => {
    if (level.status === "unlocked") {
      const diff = moment(level.lockedUntil).diff(now);
      if (level.lockedUntil && diff > 0) {
        return (
          <div className="rounded-[0.25rem] px-2 py-1 bg-error flex items-center justify-center gap-2 text-primary-80">
            <IonIcon icon={lockClosed} className="text-sm" />
            <span>{moment.utc(diff).format("HH:mm:ss")}</span>
          </div>
        );
      } else {
        return (
          <div className="rounded-[0.25rem] px-2 py-1 bg-secondary-50 flex items-center justify-center">
            <IonIcon icon={play} className="text-primary-80 text-sm" />
          </div>
        );
      }
    } else if (level.status === "complete") {
      return (
        <div className="rounded-[0.25rem] px-2 py-1 bg-success flex items-center justify-center">
          <IonIcon icon={checkmark} className="text-primary-80 text-sm" />
        </div>
      );
    } else {
      return (
        <div className="rounded-[0.25rem] px-2 py-1 bg-primary-80 flex items-center justify-center">
          <IonIcon icon={lockClosed} className="text-primary-20 text-sm" />
        </div>
      );
    }
  };

  return (
    <IonCard
      className="m-0 bg-primary-60 text-white "
      button
      disabled={level.status === "locked"}
      routerLink={`/quest/levels/${level.level}/${nextUnclearedStage}`}
    >
      <div className="flex flex-col p-4 gap-1">
        <div className="flex justify-between">
          <div className="bg-primary-80 rounded-[0.25rem] px-2 py-1 text-white">
            Quest {level.level}
          </div>
          {getStatusElement()}
        </div>
        <h3 className="text-2xl font-semibold">{level.levelName}</h3>
        <div className="flex items-center gap-1 text-primary-10">
          <IonIcon icon={calendarClearOutline} className="text-white text-sm" />
          {moment(level.marketDateFrom).format("DD MMM YYYY")} -{" "}
          {moment(level.marketDateTo).format("DD MMM YYYY")}
        </div>
        <ProgressBarAlt percent={level.completionPercent} />
      </div>
    </IonCard>
  );
};
export default QuoQuestLevelCard;
